import gql from 'graphql-tag';

export const GENERATE_NEW_WILL_MUTATION = gql`
  mutation downloadWill($testatorId: ID!, $emailTestator: Boolean) {
    downloadWill(testatorId: $testatorId, emailTestator: $emailTestator) {
      willVersion {
        id
        status
        url
        version
        createdAt
        updatedAt
        dateStored
        processed
        uploadedWills {
          id
          status
          url
          comments
          version
          createdAt
        }
      }
      url
      processWill
    }
  }
`;

export const GET_NEW_WILL_MUTATION = gql`
  mutation getWill($testatorId: ID!) {
    getWill(testatorId: $testatorId) {
      willVersion {
        id
        status
        url
        version
        createdAt
        updatedAt
        dateStored
        processed
        uploadedWills {
          id
          status
          url
          comments
          version
          createdAt
        }
      }
      url
      processWill
      processing
    }
  }
`;

export const PREVIEW_WILL_MUTATION = gql`
  mutation previewWill($testatorId: ID!) {
    previewWill(testatorId: $testatorId) {
      previewWillVersion {
        id
        url
        version
        createdAt
        processed
      }
      url
      processWill
    }
  }
`;

export const GET_WILL_PREVIEW_MUTATION = gql`
  mutation getWillPreview($testatorId: ID!) {
    getWillPreview(testatorId: $testatorId) {
      previewWillVersion {
        id
        url
        version
        createdAt
        processed
      }
      url
      processWill
      processing
    }
  }
`;
